import { render, staticRenderFns } from "./RegisterStudyFormPartner.vue?vue&type=template&id=bf07fc50&scoped=true"
import script from "./RegisterStudyFormPartner.vue?vue&type=script&lang=js"
export * from "./RegisterStudyFormPartner.vue?vue&type=script&lang=js"
import style0 from "./RegisterStudyFormPartner.vue?vue&type=style&index=0&id=bf07fc50&prod&scoped=true&lang=css"
import style1 from "./RegisterStudyFormPartner.vue?vue&type=style&index=1&id=bf07fc50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf07fc50",
  null
  
)

export default component.exports